import { NavBar } from '@/components'
export default function Header()
{
    return (
        <header className='bg-neutral-900 fixed w-full top-0 z-30'>
            <NavBar></NavBar>
        </header>
    );
}